/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：41
 */

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import * as Language from "../../ui/language"
import * as EventStore from "../../../editor/redux/store"
import * as Actions from "../../../editor/redux/common/actions"

export const axiosWithCredentials: AxiosInstance = axios.create({
  timeout: 2e4,
  withCredentials: true
})

axiosWithCredentials.interceptors.request.use(
  (config: AxiosRequestConfig): AxiosRequestConfig => config,
  (error: unknown): Promise<never> => Promise.reject(error)
)

axiosWithCredentials.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => response,
  (error: AxiosError): Promise<never> => {
    if (!error.response && (!navigator.onLine || navigator?.connection?.rtt === 0)) {
      const language: Language.Language = EventStore.getLanguage()
      EventStore.getStore().dispatch(Actions.showCommonToastInfoAction({
        message: Language.format(language, "axios.weakNetworkTips").toString(),
        type: "error"
      }))
    }
    return Promise.reject(error)
  }
)

export { axiosWithCredentials as a }
